// TODO: Expand the location worker to be a 'shared' worker service that can be used
//       throughout the app?
//       For that, we need to add worker pool to manage the tasks and make sure
//       we don't have too many workers running at the same time.
//       The package workerpool seems to be a good option for this. But it doesn't support
//       code from imported module (like the db we created from Dexie) rn.

import { ALL_LOCATIONS } from '@solinkcorp/vd-common';
import { produce } from 'immer';
import { type VideoDiscoverySite } from 'utils/types';
import { LOCATION_NO_CACHE_FIELDS, SolinkDexie } from '../@solink/vd-data-layer/db';

export const SAVE_LOCATIONS_IN_DB = 'SAVE_LOCATIONS_IN_DB';

// Save processed location list in IndexedDB
async function saveLocationsInDb(locations: VideoDiscoverySite[], dbId: string) {
  const db = new SolinkDexie(dbId);
  try {
    await db.locations.clear();
    console.debug('Cleared locations');
  } catch (err) {
    console.error('Error clearing locations', err);
  }

  // Remove sensitive fields before caching
  const safeLocationsToCache = locations.map((location) =>
    produce(location, (draft) => {
      // Remove location-level fields
      LOCATION_NO_CACHE_FIELDS.forEach((field) => {
        delete draft[field];
      });
    }),
  );

  try {
    await db.locations.bulkPut(safeLocationsToCache);
    console.debug('Cached locations');
  } catch (err) {
    console.error('Error caching locations', err);
  }
}

self.onmessage = function (e) {
  const data = e.data;
  const { locations, dbId, taskType } = data;

  switch (taskType) {
    case SAVE_LOCATIONS_IN_DB: {
      const locationsWithoutAll = locations.filter(
        (location: VideoDiscoverySite) => location.id !== ALL_LOCATIONS,
      );
      saveLocationsInDb(locationsWithoutAll, dbId);
      break;
    }
  }
};
